<template>
<div class="container work-we-love">
    <div class="grid content-grid-two-rows">
      <slot></slot>
    </div>
</div>
</template>

<script>
export default {
  name: 'caseGrid'
}
</script>

<style lang="scss" scoped>

.content-grid-two-rows{

  .column{
    max-width: 448px;
    margin-bottom: layout-val-8(18);
    position: relative;
    

     &::after{
        content:'';
        background-image: url(../../assets/Folded_Paper_asset_arrow_right.png);
        background-position: right;
        background-size: 100%;
        background-repeat: no-repeat;
        width: 30px;
        height: 30px;
        position: absolute;
        right: 32px;
        bottom: 60px;
        opacity: 0;
        @include transition-cubic-out-back;
      }

      &:hover::after{
        opacity: 1;
        bottom: 140px;
        @include transition-cubic-out-back;
      }

       img{
        max-width: 448px;
        display: block;
        @include transition;
        border-radius: 15px;
        position: relative;
        width: 100%;
        margin-bottom: layout-val-8(2);

          &:active{
            transform: scale(0.98); 
            @include transition;
            box-shadow: none;
          }
      }
      
      span{
        color:$tekst-color-grey;
        font-weight: 900;
        font-family: $font-stack-copy;
      }
  }

  .tca{
    img{
      box-shadow: 0 10px 20px 0 rgba(206,66,59,0.15), 0 10px 7px 0 rgba(206,66,59,0.02);
    }
  }
  .avans{
    img{
      box-shadow: 0 10px 20px 0 rgba(36,52,119,0.15), 0 10px 7px 0 rgba(36,52,119,0.02);
    }
  }
  .gowallet{
    img{
      box-shadow: 0 10px 20px 0 rgba(181,242,235,0.15), 0 10px 7px 0 rgba(181,242,235,0.02);
    }  
  }
  .newschain{
    img{
      box-shadow: 0 10px 20px 0 rgba(77,170,213,0.15), 0 10px 7px 0 rgba(77,170,213,0.02);
    }
  }
  .loud{
    img{
      box-shadow: 0 10px 20px 0 rgba(244,115,26,0.15), 0 10px 7px 0 rgba(244,115,26,0.02);
    }
  }
  .mobilyze{
    img{
      box-shadow: 0 10px 20px 0 rgba(16,184,105,0.15), 0 10px 7px 0 rgba(16,184,105,0.02);
    }  
  }
  .firstenergy{
    img{
	    box-shadow: 0 10px 20px 0 rgba(233,37,43,0.15), 0 10px 7px 0 rgba(233,37,43,0.02);
    }
  }
  .unlock{
    img{
	    box-shadow: 0 10px 20px 0 rgba(255,226,238.15), 0 10px 7px 0 rgba(255,226,238,0.02);
    }
  }
}

.work-we-love{
  .row{
    width: 100%;
  }
  ul{
    list-style: none;

      li{
        width: 50%;
        max-height: 500px;
        
          .router-link{
            text-decoration: none;
          }
      }

      li:nth-child(odd){
        float: left;
      }

      li:nth-child(even){
        float: right;
      }
  }

  .intro, .end{
    &::after{
      display: none;
    }
  }

  .grid:after {
    content: "";
    display: table;
    clear: both;
  }
}

.case-page{
  .work-we-love ul li{
    width: 48%;
  }
}

@media screen and (max-width: 720px) {
  .work-we-love ul{
    padding: 0;
  }
}



</style>